import { billingClient } from '@/lib/api/ts-rest';
import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';

export function useBillingCenterPreview(runId: string, siteId: string) {
  return useQuery({
    queryKey: queryKeys.billing.centerPreview(runId, siteId),
    queryFn: async () => {
      const res = await billingClient.getCenterPreview({
        params: { id: runId, siteId },
      });
      if (res.status !== 200) throw new Error('Failed to load preview');
      return res.body;
    },
  });
}
